import * as R from 'ramda';
import { useMutation } from '@apollo/client';

export const useCommitMutation = (mutation, { dataProp }) => {
  const [mutate, { loading, called }] = useMutation(mutation);

  const onFormSubmit = (input, done, opts = {}) => {
    mutate({
      ...opts,
      variables: { input },
      onCompleted: (response) => {
        const data = R.prop(dataProp, response);
        const { ok, error } = data;
        done(ok, error, R.omit(['ok', 'error'], data));
      },
      onError: (error) => {
        done(false, JSON.stringify(error, null, 4));
      }
    });
  };

  return {
    onFormSubmit,
    loading,
    called
  };
};
